
import React from 'react';
import { Modal } from 'react-bootstrap'
import Register from './Register'

class RegisterModal extends React.Component {
    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Registrar Comercio
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Register updateusuarios={() => this.props.updateusuarios} />
                </Modal.Body>
            </Modal>
        );
    }
}

export default RegisterModal;